import { AxiosResponse } from 'axios';

import { client, clientWithHttpResponse } from '@api/client';
import { URL } from '@api/urls';

import { IDefaultUploadUrlApi, IDownloadUrl } from '@interfaces/common/file';
import { IDefaultUploadUrlResponse } from '@interfaces/common/response';
import { ISubmitFieldsMappingDTO } from '@interfaces/import/dto/importDTO';
import { ISystemFields } from '@interfaces/import/import';

const {
	createPolygonUploadUrl,
	polygonSampleUrl,
	importPolygons,
	importPolygonFieldSamples,
	importPolygonSystemFields,
	importStatistics,
	importPolygonExecute,
	importPolygonFieldsMapping,
} = URL;

export const getPolygonUploadUrl = ({ fileName }: IDefaultUploadUrlApi): Promise<IDefaultUploadUrlResponse> => {
	return client.post(`/${createPolygonUploadUrl}`, { fileName });
};

export const getPolygonSampleUrl = (): Promise<IDownloadUrl> => client.get(`/${polygonSampleUrl}`);

export const runPolygonFieldSamples = (id: string): Promise<void> => {
	return client.post(`/${importPolygons}/${id}${importPolygonFieldSamples}`, {});
};

export const getPolygonFieldSamples = (id: string): Promise<AxiosResponse> => {
	return clientWithHttpResponse.get(`/${importPolygons}/${id}${importPolygonFieldSamples}`);
};

export const getPolygonsSystemFields = (): Promise<ISystemFields[]> => client.get(`/${importPolygonSystemFields}`);

export const getImportPolygonStats = (id: string) => {
	return clientWithHttpResponse.get(`/${importPolygons}/${id}${importStatistics}`);
};

export const runImportPolygonStats = (id: string): Promise<AxiosResponse> => {
	return client.post(`/${importPolygons}/${id}${importStatistics}`, {});
};

export const executeImportPolygons = (id: string): Promise<void> => {
	return client.post(`/${importPolygons}/${id}${importPolygonExecute}`, {});
};

export const saveFieldsMapping = ({ id, fieldsMapping }: ISubmitFieldsMappingDTO) => {
	return client.post(`/${importPolygons}/${id}${importPolygonFieldsMapping}`, { fieldsMapping });
};
